<template>
  <div>
    <div class="test-button">
      <button class="btn btn-primary" @click="enter">Request</button>
    </div>
    <div class="test-content">{{ response }}</div>
  </div>
</template>

<script>
import HttpClient from "@/models/HttpClient.js";
export default {
  data() {
    return {
      response: null,
    };
  },
  methods: {
    async enter() {
      const data = {
        name: "Lipdukas 200 x 200",
        width: 200,
        height: 200,
        margin_left: 10,
        margin_top: 10,
        template_texts: [
          {
            x1: 10,
            y1: 10,
            width: 50,
            height: 20,
            font_size: 12,
            bold: false,
            italic: true,
            text: "Bandymas",
          },
          {
            x1: 30,
            y1: 10,
            width: 50,
            height: 20,
            font_size: 16,
            bold: false,
            italic: true,
            text: "P3",
          },
        ],
        template_boxes: [
          {
            x1: 10,
            y1: 10,
            width: 190,
            height: 190,
          },
        ],
        template_qr_codes: [
          {
            x1: 10,
            y1: 150,
            width: 50,
            height: 40,
          },
        ],
        template_images: [
          {
            x1: 160,
            y1: 10,
            width: 30,
            height: 20,
          },
        ],
        order_suppliers: [
          {
            supplier_id: 1,
            status: "0",
          },
          {
            supplier_id: "2",
            status: "0",
          },
          {
            supplier_id: "8",
            status: "0",
          },
          {
            supplier_id: "9",
            status: "0",
          },
        ],
      };
      const client = new HttpClient();
      const response = await client.instance.post(
        "orders/9309/suppliers",
        data
      );
      console.log(response.data);
      this.response = response.data;
    },
  },
};
</script>

<style scoped>
.test-button {
  margin: auto;
  width: 200px;
  padding: 50px;
}
.test-content {
  margin: auto;
  width: 1000px;
  background: khaki;
}
</style>